import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsCol, IFormItemsControls} from '../../../../interface/form-structure';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {GlobalObjectService} from '../../../../class/global-obj';
import {IFieldShema} from '@usteknoloji/noosgrid';
import * as _ from 'lodash';

export interface IValueMap {
    field_name: string;
    field_alias: string;
    list_order: number;
    title?: string;
}

@Component({
    selector: 'noos-viewlabel',
    templateUrl: './viewlabel.component.html',
    styleUrls: ['./viewlabel.component.scss']
})
@NoosFormTypeService.register('viewLabel')
export class ViewlabelComponent implements OnInit, AfterViewInit, FormItemComponentInterface, OnChanges {

    prop: IFormItemsControls;
    isFilter = false;
    thisAppearance: any = 'outline';

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    formFieldStructure: IFieldShema[];
    formRecordData: any;

    headerValue = '';
    className = '';

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    valueList: IValueMap[] = [];

    constructor() {
    }

    ngOnInit() {

        this.formFieldStructure = _.orderBy(GlobalObjectService.getVar('formFieldStructure_' + this.formId.toString()), ['list_order'], ['ASC']);
        this.formRecordData = GlobalObjectService.getVar('formRecordData_' + this.formId.toString());

        console.log('-##---formField-->', this.formFieldStructure);
        console.log('-##---recordData-->', this.formRecordData);
    }

    _get_col_percent(items: IValueMap[]) {

        const ret = (100 / items.length);
        return ret.toString();
    }


    ngAfterViewInit(): void {

        this.loadData();

    }


    loadData(){

        console.log('----Prop-->', this.prop);
        let order = -1;
        this.prop.viewOptions.selectedItems.forEach(x => {
            order += 1;
            let fieldAlias = '';
            let fieldName = '';
            let fieldTitle = '';
            let fieldValue = '';

            const isField2 = this.formFieldStructure.filter(i => i.source_field_name === x.value);
            if (isField2.length > 0) {
                isField2.forEach(p => {
                    fieldValue += ' ' + this.convert_value(this.formRecordData[p.field_alias]);
                });

                fieldAlias = isField2[0].field_alias;
                fieldName = isField2[0].field_name;
                fieldTitle = x.title;

            } else {
                const isField = this.formFieldStructure.filter(i => i.field_name === x.value);
                if (isField.length > 0) {
                    fieldAlias = isField[0].field_alias;
                    fieldName = isField[0].field_name;
                    fieldTitle = isField[0].field_title;
                    fieldValue = this.convert_value(this.formRecordData[isField[0].field_alias]);
                }
            }

            this.valueList.push({
                field_name: fieldValue.trim(),
                field_alias: fieldAlias,
                list_order: order,
                title: fieldTitle
            });

        });

        this.valueList = _.orderBy(this.valueList, ['list_order'], ['ASC']);

        /*
        let formatString = this.prop.viewOptions.formatString;
        valueList.forEach(x => {
            const fieldData = this.formRecordData[x.field_alias];
            const isFind = '{' + x.list_order.toString() + '}';
            while (formatString.indexOf(isFind) !== -1) {
                formatString = formatString.replace(isFind, fieldData);
            }

        });
         */

        // this.headerValue = formatString;
        this.className = this.prop.viewOptions.cssClass !== undefined
            ? this.prop.viewOptions.cssClass.replace('.', '') : '';
    }

    convert_value(val) {
        if (val === null || val === undefined) {
            return '';
        }
        if (val.toString() === 'true') {
            return 'Evet';
        } else if (val.toString() === 'false') {
            return 'Hayır';
        }
        return val;
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log('header change******');
        this.loadData();
    }

}

